import { Directive, ElementRef, Input, OnInit } from '@angular/core'
import { AuthorizationService } from './authorization.service'

@Directive({
  selector: '[hideIfNot]'
})
export class HideIfNotDirective implements OnInit {

  @Input('hideIfNot') role: string
  constructor(
    private authorization: AuthorizationService,
    private el: ElementRef,
  ) { }

  ngOnInit() {
    if (this.role.includes('||')) {
      let split = this.role.split('||')
      let hasPermission = false
      split.forEach(element => {
        if (element.includes("!")) {
          if (!this.authorization.hasPermission(element.replace(" ", "").replace("!", ""))) {
            hasPermission = true
          }
        } else {
          if (this.authorization.hasPermission(element.replace(" ", ""))) {
            hasPermission = true
          }
        }
      })
      if (!hasPermission) {
        this.el.nativeElement.style.display = 'none'
      }
    } else if (this.role.includes("!") && this.authorization.hasPermission(this.role.replace("!", ""))) {
      this.el.nativeElement.style.display = 'none'
    } else if (!this.role.includes("!") && !this.authorization.hasPermission(this.role)) {
      this.el.nativeElement.style.display = 'none'
    }
  }
}
